module.exports = __webpack_public_path__ + "img/equity.4576ba37.svg";